import { useState } from "react";
import { useParams } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ContentType2 from "./ContentType2";
import ContentType3 from "./ContentType3";
import ContentType4 from "./ContentType4";
import { contentTypes } from "../../../../mocks/contentTypeTwilio";
import ContentType5 from "./ContentType5";
import ContentType6 from "./ContentType6";
import ContentType1 from "./ContentType1";
import ContentType7 from "./ContentType7";
import ContentType8 from "./ContentType8";
// import ContentType9 from "./ContentType9";

interface URLParams {
    name?: string;
    contentType?: string;
}

export default function FinalizarCriacaoTemplate() {
    const [showCollapseInfo, setShowCollapseInfo] = useState(true);
    const [showCollapseContent, setShowCollapseContent] = useState(true);
    const { name, contentType } = useParams<URLParams>();

    const contentTypeObj = contentTypes.find(
        (type) => type.value === contentType
    );
    const contentTypeLabel = contentTypeObj ? contentTypeObj.label : "-";

    const handleCollapseToggleInfo = () => setShowCollapseInfo((prev) => !prev);
    const handleCollapseToggleContent = () =>
        setShowCollapseContent((prev) => !prev);

    console.log(contentType, "contentType");

    const renderComponent = () => {
        switch (contentType) {
            case "text":
                return <ContentType1 />;
            case "media":
                return <ContentType2 />;
            case "quick_reply":
                return <ContentType3 />;
            case "call_to_action":
                return <ContentType4 />;
            case "list_picker":
                return <ContentType5 />;
            case "card":
                return <ContentType6 />;
            case "whatsapp_card":
                return <ContentType7 />;
            case "whatsapp_authentication":
                return <ContentType8 />;
            // case "catalog":
            //     return <ContentType9 />;
            default:
                return null;
        }
    };

    return (
        <div className="card card-body">
            <div className="mb-10">
                <h3>{name}</h3>
                <div
                    className="p-4 bg-light-dark rounded-top"
                    onClick={handleCollapseToggleInfo}
                    style={{ cursor: "pointer" }}
                >
                    {showCollapseInfo ? (
                        <>
                            <FontAwesomeIcon icon={faAngleDown} /> Informações
                            Gerais
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faAngleRight} /> Informações
                            Gerais
                        </>
                    )}
                </div>
                <Collapse in={showCollapseInfo}>
                    <div className="rounded-bottom p-5 bg-light d-flex flex-wrap">
                        <div className="flex-grow-1 mb-4">
                            <div>
                                <h6>Nome do Template</h6> {name}
                            </div>
                            <div className="mt-4">
                                <h6>Status de aprovação</h6> {}
                            </div>
                        </div>
                        <div className="flex-grow-1 mb-4">
                            <div>
                                <h6>Tipo de conteúdo</h6> {contentTypeLabel}
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>

            <div>
                <div
                    className="p-4 bg-light-dark rounded-top"
                    onClick={handleCollapseToggleContent}
                    style={{ cursor: "pointer" }}
                >
                    {showCollapseContent ? (
                        <>
                            <FontAwesomeIcon icon={faAngleDown} /> Conteúdo
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faAngleRight} /> Conteúdo
                        </>
                    )}
                </div>
                <Collapse in={showCollapseContent}>
                    <div className="rounded-bottom p-5 bg-light d-flex flex-column flex-wrap">
                        <div className="flex-grow-1">
                            <div>
                                <h6>
                                    Configure o conteúdo - {contentTypeLabel}
                                </h6>
                            </div>
                        </div>
                        {renderComponent()}
                    </div>
                </Collapse>
            </div>
        </div>
    );
}
